module.exports = __webpack_public_path__ + "static/img/logout.e32167f5.png";